// extracted by mini-css-extract-plugin
export default {"box":"comparison_box__9zKpe","bottom":"comparison_bottom__rS-a5"};